import BillingsOrderCargoRailyRecalculateParams, {
  BillingsOrderCargoRailyRecalculateParamsBillingNode,
} from "../../../../../common/services/billings/order/cargo-raily/recalculate/billings-order-cargo-raily-recalculate-params";
import BillingsNode from "../../../common/types/billings-node";
import BillingFormData from "../types/billing-form.data";

const createRecalculateRequestBillingNode = (
  billingsNode: BillingsNode,
): BillingsOrderCargoRailyRecalculateParamsBillingNode => {
  return {
    checkoutDate: billingsNode.checkoutDate,
    description: billingsNode.description,
    distance: billingsNode.distance,
    haltingTime: billingsNode.haltingTime,
    highwayCharge: billingsNode.highwayCharge,
    id: billingsNode.id,
    lat: billingsNode.lat,
    lon: billingsNode.lon,
    nodeId: billingsNode.nodeId,
    orderId: billingsNode.orderId,
    plannedDate: billingsNode.plannedDate,
    plannedDistance: billingsNode.plannedDistance,
    allowCharge: billingsNode.isHighwayAllowed,
    checkoutEventId: billingsNode.checkoutEventUuid,
    editableCoordinates: billingsNode.isEditable,
  };
};

const createRecalculateRequestBillingNodes = (
  billingsNodes: BillingsNode[],
): BillingsOrderCargoRailyRecalculateParamsBillingNode[] => {
  return billingsNodes.map(createRecalculateRequestBillingNode);
};

const createRecalculateRequest = (
  data: BillingFormData,
): BillingsOrderCargoRailyRecalculateParams => {
  return {
    billingNodes: createRecalculateRequestBillingNodes(data.billingNodes),
    discount: data.discount,
    orderUuid: data.cargoOrderId,
  };
};

const billingRecalculateRequestFactory = {
  createRecalculateRequest,
};

export default billingRecalculateRequestFactory;
